// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/@kmijs+bundler-compiled@0.0.8/node_modules/@kmijs/bundler-compiled/compiled/css-loader/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/@kmijs+bundler-compiled@0.0.8/node_modules/@kmijs/bundler-compiled/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkbox-with-text-area___ALB8K {\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://./../../features/mpc-common/src/components/SForm/SFormElement/CheckboxWithTextArea/index.less"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF","sourcesContent":[".checkbox-with-text-area {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox-with-text-area": "checkbox-with-text-area___ALB8K"
};
export default ___CSS_LOADER_EXPORT___;
